import { Category } from "../../../../common/types/categories/category";
import { CallApi, handleJSONResponse } from "./common";

const callAPI = CallApi("categories");

export const getGenres = async (
): Promise<Category<any>[]> => {
  const response = await callAPI("/genre", "GET");

  return handleJSONResponse(response);
};

export const getStores = async (
  ): Promise<Category<any>[]> => {
    const response = await callAPI("/platform", "GET");
  
    return handleJSONResponse(response);
  };
